import * as React from "react";
import { Grid } from "semantic-ui-react";
import { RouteComponentProps, Route, Switch, Redirect } from "react-router";

import SettingsMenu from "../../components/SettingsMenu/SettingsMenu";
import SettingsProfile from "../../components/SettingsProfile/SettingsProfile";
import SettingsAccount from "../../components/SettingsAccount.tsx/SettingsAccount";
import SettingsDisplay from "../../containers/SettingsDisplay/SettingsDisplay";
import SettingsPrivacy from "../../containers/SettingsPrivacy/SettingsPrivacy";
import SectionErrorBoundary from "../../components/ErrorBoundaries/SectionErrorBoundary";
import SectionSkeleton from "../../components/Skeletons/SectionSkeleton";
import "./Settings.css";

const LazySettingsProfile = React.lazy(() => import("../../components/SettingsProfile/SettingsProfile"));
const LazySettingsAccount = React.lazy(() => import("../../components/SettingsAccount.tsx/SettingsAccount"));
const LazySettingsDisplay = React.lazy(() => import("../../containers/SettingsDisplay/SettingsDisplay"));
const LazySettingsPrivacy = React.lazy(() => import("../../containers/SettingsPrivacy/SettingsPrivacy"));

class Settings extends React.Component<RouteComponentProps<void>, {}> {
    render() {
        const { match } = this.props;
        return (
            <div className="settings-page-modern">
                <Grid stackable={true}>
                    <Grid.Column mobile={5} tablet={5} computer={4} >
                        <div className="settings-sidebar">
                            <SettingsMenu />
                        </div>
                    </Grid.Column>
                    <Grid.Column mobile={11} tablet={11} computer={12}>
                        <div className="settings-content-area">
                            <React.Suspense fallback={<SectionSkeleton />}>
                                <Switch>
                                    <Redirect exact={true} path={`${match.url}`} to={`${match.url}/profile`} />
                                    <Route path={`${match.url}/profile`}>
                                        <SectionErrorBoundary>
                                            <SettingsProfile {...this.props} />
                                        </SectionErrorBoundary>
                                    </Route>
                                    <Route path={`${match.url}/account`}>
                                        <SectionErrorBoundary>
                                            <SettingsAccount />
                                        </SectionErrorBoundary>
                                    </Route>
                                    <Route path={`${match.url}/display`}>
                                        <SectionErrorBoundary>
                                            <SettingsDisplay />
                                        </SectionErrorBoundary>
                                    </Route>
                                    <Route path={`${match.url}/privacy`}>
                                        <SectionErrorBoundary>
                                            <SettingsPrivacy />
                                        </SectionErrorBoundary>
                                    </Route>
                                </Switch>
                            </React.Suspense>
                        </div>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

export default Settings;
